// Modified functions to accept product_id as parameter
function addGiftWrapProductToCart(productId) {
  const formData = {
    items: [{
      id: productId,
      quantity: 1,
    }]
  };


  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(data => {
      console.log('Product added:', data);
      refreshCart();
    })
    .catch((error) => {
      console.error('Error:', error);
      // Show error message to user
    })
    .finally(() => {
      // Remove loading state
      // document.body.classList.remove('cart-loading');
    });
}

function removeGiftWrapProductFromCart(productId) {
  const updates = {
    [productId]: 0
  };

  // Add loading state if needed
  // document.body.classList.add('cart-loading');

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(data => {
      console.log('Product removed:', data);
      refreshCart();
    })
    .catch((error) => {
      console.error('Error:', error);
      // Show error message to user
    })
    .finally(() => {
      // Remove loading state
      // document.body.classList.remove('cart-loading');
    });
}

// Combined initialization function
function initializeGiftWrap() {
  const gift_wrap_box = document.querySelector('.gift-wrapper-note');
  const checkbox = document.querySelector('#cart-gift-wrap');
  const main_cart_wrap = document.querySelector('.main-cart-gift-wrapper');

  // Handle cart drawer gift wrap
  if (gift_wrap_box && checkbox) {
    const product_id = gift_wrap_box.getAttribute('data-product-id');
    const sec_container = gift_wrap_box.querySelector('.cart-gift-container');
    const add_product = gift_wrap_box.querySelector('.drawer_add-on');

    if (product_id && sec_container && add_product) {
      checkbox.addEventListener('change', function () {
        if (checkbox.checked) {
          sec_container.style.display = 'block';
          checkbox.setAttribute('checked', 'checked');
          bindGiftWrapCheckbox(add_product, product_id);
        } else {
          sec_container.style.display = 'none';
          checkbox.removeAttribute('checked');
        }
      });
    }
  }

  // Handle main cart gift wrap
  if (main_cart_wrap) {
    const main_product_id = main_cart_wrap.getAttribute('data-product-id');
    const main_add_product = main_cart_wrap.querySelector('.drawer_add-on');

    bindGiftWrapCheckbox(main_add_product, main_product_id);
  }
}


function refreshCart() {
  // First refresh the drawer
  fetch('/?section_id=cart-drawer')
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.text();
    })
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Update cart drawer
      const newItems = doc.querySelector('#cart-drawer__items');
      const currentItems = document.querySelector('#cart-drawer__items');
      if (newItems && currentItems) {
        currentItems.innerHTML = newItems.innerHTML;
      }

      const newTotal = doc.querySelector('.cart-drawer__button-price');
      const currentTotal = document.querySelector('.cart-drawer__button-price');
      if (newTotal && currentTotal) {
        currentTotal.innerHTML = newTotal.innerHTML;
      }

      // Now refresh the main cart
      return fetch('/cart?view=main-cart');
    })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.text();
    })
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Update main cart
      const newMainCart = doc.querySelector('.order-summary__body');
      const currentMainCart = document.querySelector('.order-summary__body');
      
      if (newMainCart && currentMainCart) {
        currentMainCart.innerHTML = newMainCart.innerHTML;
      }

      const newMainTotal = doc.querySelector('.cart-recap');
      const currentMainTotal = document.querySelector('.cart-recap');
      if (newMainTotal && currentMainTotal) {
        currentMainTotal.innerHTML = newMainTotal.innerHTML;
      }

      // 🔄 Re-initialize gift wrap logic after DOM replacement
      initializeGiftWrap();
      checkCartForGiftWrap();
    })
    .catch(error => {
      console.error('Error refreshing cart:', error);
    });
}

// Store checkbox state in localStorage when changed
function bindGiftWrapCheckbox(add_product, product_id) {
  if (!add_product || !product_id) return;

  if (!add_product.hasAttribute('data-bound')) {
    add_product.addEventListener('change', function() {
      if (add_product.checked) {
        add_product.setAttribute('checked', 'checked');
        addGiftWrapProductToCart(product_id);
        localStorage.setItem('gift_wrap_checked', 'true');
        // Don't update text immediately
      } else {
        add_product.removeAttribute('checked');
        removeGiftWrapProductFromCart(product_id);
        localStorage.removeItem('gift_wrap_checked');
        // Don't update text when unchecked
      }
    });
    add_product.setAttribute('data-bound', 'true');
  }
}

// Update text only on page load if checkbox was previously checked
function updateGiftWrapTextOnLoad() {
  const isChecked = localStorage.getItem('gift_wrap_checked') === 'true';
  if (!isChecked) return;

  const wrapper = document.querySelector('.gift-wrapper-note');
  const mainmessage = document.querySelector('.main_message');
  const handletext = wrapper ? wrapper.getAttribute('data-product-handle') : '';
  const finalhandle = handletext ? handletext.replace("-", " ") : "";

  if (mainmessage) {
    mainmessage.innerHTML = `${finalhandle} included`;
  }
}



// Combined cart check on load
function checkCartForGiftWrap() {
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(cart => {
      // Check cart drawer
      const gift_wrap_box = document.querySelector('.gift-wrapper-note');
      if (gift_wrap_box) {
        const product_id = gift_wrap_box.getAttribute('data-product-id');
        const checkbox = document.querySelector('#cart-gift-wrap');
        const sec_container = gift_wrap_box.querySelector('.cart-gift-container');
        const add_product = gift_wrap_box.querySelector('.drawer_add-on');

        if (product_id && checkbox && sec_container && add_product) {
          const isGiftWrapInCart = cart.items.some(item => item.id == product_id);
          if (isGiftWrapInCart) {
            checkbox.checked = true;
            checkbox.setAttribute('checked', 'checked');
            sec_container.style.display = 'block';
            add_product.checked = true;
            add_product.setAttribute('checked', 'checked');

            bindGiftWrapCheckbox(add_product, product_id);
          }
        }
      }

      // Check main cart
      const main_cart_wrap = document.querySelector('.main-cart-gift-wrapper');
      if (main_cart_wrap) {
        const main_product_id = main_cart_wrap.getAttribute('data-product-id');
        const main_add_product = main_cart_wrap.querySelector('.drawer_add-on');

        if (main_product_id && main_add_product) {
          const isGiftWrapInCart = cart.items.some(item => item.id == main_product_id);
          if (isGiftWrapInCart) {
            main_add_product.checked = true;
            main_add_product.setAttribute('checked', 'checked');

            bindGiftWrapCheckbox(main_add_product, main_product_id);
          }
        }
      }
    })
    .catch(error => {
      console.error('Error checking cart:', error);
    });
}


function observeGiftWrapCheckbox() {
  const observer = new MutationObserver(() => {
    const checkbox = document.querySelector('#cart-gift-wrap');
    const wrapper = document.querySelector('.gift-wrapper-note');
    
    if (checkbox && wrapper && !checkbox.hasAttribute('data-observed')) {
      initializeGiftWrap();  // reinitialize event bindings
      checkCartForGiftWrap(); // check cart state
      checkbox.setAttribute('data-observed', 'true'); // prevent duplicate binding
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Initialize everything
document.addEventListener('DOMContentLoaded', () => {
  initializeGiftWrap();
  checkCartForGiftWrap();
  observeGiftWrapCheckbox();
   updateGiftWrapTextOnLoad();
});
